import type { DashboardActionBox } from '../../../apiLayer/types/dashboard'
import { DashboardActionBoxType } from '../../../apiLayer/types/dashboard'

/**
 * Action boxes for Gamer Dashboard
 * Defines the quick action cards shown on the gamer dashboard
 */
export const GAMER_ACTION_BOXES: DashboardActionBox[] = [
  {
    type: DashboardActionBoxType.JOIN_TRAINING_SPRINT,
    title: 'gamer.dashboard.boxes.joinTrainingSprint.title',
    description: 'gamer.dashboard.boxes.joinTrainingSprint.description',
    buttonText: 'gamer.dashboard.boxes.joinTrainingSprint.button'
  },
  {
    type: DashboardActionBoxType.VIEW_PROGRESS,
    title: 'gamer.dashboard.boxes.viewProgress.title',
    description: 'gamer.dashboard.boxes.viewProgress.description',
    buttonText: 'gamer.dashboard.boxes.viewProgress.button'
  },
  {
    type: DashboardActionBoxType.DOWNLOAD_MATERIALS,
    title: 'gamer.dashboard.boxes.downloadMaterials.title',
    description: 'gamer.dashboard.boxes.downloadMaterials.description',
    buttonText: 'gamer.dashboard.boxes.downloadMaterials.button'
  }
]

/**
 * Info box configurations for Gamer Dashboard
 * Defines structure and translation keys
 * Values injected at runtime from real data or mocks
 */
export const GAMER_INFO_BOX_CONFIG = [
  { key: 'myActiveSprints', title: 'gamer.dashboard.infoBoxes.myActiveSprints' },
  { key: 'upcomingSessions', title: 'gamer.dashboard.infoBoxes.upcomingSessions' },
  { key: 'sessionsCompleted', title: 'gamer.dashboard.infoBoxes.sessionsCompleted' },
  { key: 'learningScore', title: 'gamer.dashboard.infoBoxes.learningScore' }
] as const
